import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table.component';
import { TableRowComponent } from './table-row.component';
import { TableHeaderRowComponent } from './table-header-row.component';
import { TableColComponent } from './table-col.component';
import { TableIdentityColComponent } from './table-identity-col.component';
import { TableSubtitleComponent } from './table-subtitle.component';
import { UtilsModule } from '../utils/utils.module';
import { TableColGroupComponent } from './table-col-group.component';
import { ButtonModule } from '../button/button.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { CdkScrollableModule } from '@angular/cdk/scrolling';

@NgModule({
  imports: [
    CommonModule,
    UtilsModule,
    ButtonModule,
    SvgIconModule,
    CdkScrollableModule,
  ],
  declarations: [
    TableComponent,
    TableRowComponent,
    TableHeaderRowComponent,
    TableColComponent,
    TableIdentityColComponent,
    TableSubtitleComponent,
    TableColGroupComponent,
  ],
  exports: [
    TableComponent,
    TableRowComponent,
    TableHeaderRowComponent,
    TableColComponent,
    TableIdentityColComponent,
    TableSubtitleComponent,
    TableColGroupComponent,
  ]
})
export class TableModule {}
